import { buttonVariants } from '@/components/ui/button'
import { X } from 'lucide-react'
import { PropsWithChildren, useState } from 'react'

type Props = PropsWithChildren<{
  title: string
  uid: string
  actions: {
    label: string
    href: string
  }[]
}>

const CallToAction = (props: Props) => {
  const [closed, setClosed] = useState(
    localStorage.getItem(`cta-${props.uid}`) === 'closed',
  )

  if (closed) {
    return null
  }

  return (
    <div className='p-4 rounded-md bg-muted border-primary border my-4'>
      <h4 className='flex items-center justify-between'>
        {props.title}
        <X
          size={16}
          className='cursor-pointer mr-2'
          onClick={() => {
            setClosed(true)
            localStorage.setItem(`cta-${props.uid}`, 'closed')
          }}
        />
      </h4>
      <div>{props.children}</div>
      <div className='mt-4 flex gap-2'>
        {props.actions.map((action, i) => (
          <a
            key={i}
            href={action.href}
            target='_blank'
            rel='noreferrer'
            className={buttonVariants({ variant: 'outline' })}
          >
            {action.label}
          </a>
        ))}
      </div>
    </div>
  )
}

export default CallToAction
